import Vue from 'vue'
import VueI18n from 'vue-i18n'
import deMessage from './de.json'
import enMessage from './en.json'
import esMessage from './es.json'
import ptMessage from './pt.json'
import getBrowserLocale from "./get-browser-locale"
import { supportedLocalesInclude } from "./supported-locales"

Vue.use(VueI18n)

const messages = {
  de: deMessage,
  en: enMessage,
  es: esMessage,
  pt: ptMessage
}

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })

  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "en"
  }
}

const i18n = new VueI18n({
  locale: getStartingLocale(),
  messages,
  fallbackLocale: 'en',
  silentFallbackWarn: true
})

export default i18n
